import { Check } from "lucide-react";
import { planInfo, money, centsMoney } from "@/lib/plans";

const tooSmall = (p, use) => {
  const bits = [];
  if (p.depots !== null && use.depots > p.depots) bits.push(`${use.depots} depots`);
  if (p.crew !== null && use.crew > p.crew) bits.push(`${use.crew} crew`);
  return `Too small for your ${bits.join(" and ")}`;
};

const CadenceToggle = ({ value, onChange }) => (
  <div className="inline-flex rounded-full bg-secondary p-1" data-testid="billing-cadence">
    {[["monthly", "Monthly"], ["yearly", "Yearly · 2 months free"]].map(([v, label]) => (
      <button key={v} type="button" onClick={() => onChange(v)} data-testid={`billing-cadence-${v}`}
        className={`rounded-full px-3.5 py-1.5 text-xs font-semibold transition-colors ${value === v ? "bg-foreground text-background" : "text-muted-foreground hover:text-foreground"}`}>{label}</button>
    ))}
  </div>
);

// Plan cards for the billing panel. Plans that can't hold the company's current depots/crew are disabled.
export const PlanPicker = ({ billing, value, onChange }) => {
  const off = billing.founding_price ? 0.7 : 1;
  return (
    <div className="space-y-3">
      <CadenceToggle value={value.cadence} onChange={(cadence) => onChange({ ...value, cadence })} />
      <div className="grid sm:grid-cols-3 gap-3">
        {billing.plans.map((p) => {
          const picked = value.plan === p.id;
          const ex = p.price * (value.cadence === "yearly" ? 10 : 1) * off;
          return (
            <button key={p.id} type="button" disabled={!p.fits} onClick={() => onChange({ ...value, plan: p.id })} data-testid={`billing-plan-${p.id}`}
              className={`text-left rounded-xl border p-4 transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${picked ? "border-primary bg-primary/5 ring-1 ring-primary" : "border-border hover:border-primary/50"}`}>
              <p className="font-display font-bold">{p.name}</p>
              <p className="mt-1"><span className="font-display text-2xl font-extrabold">{money(Math.round(ex * 100) / 100)}</span>
                <span className="text-xs text-muted-foreground"> /{value.cadence === "yearly" ? "yr" : "mo"} + GST</span></p>
              <p className="text-[11px] text-muted-foreground">{centsMoney(p.charge[value.cadence])} incl. GST</p>
              <ul className="mt-2 space-y-1 text-xs">
                {planInfo(p.id).limits.map((l) => <li key={l} className="flex items-center gap-1.5"><Check className="w-3.5 h-3.5 text-primary" />{l}</li>)}
              </ul>
              {!p.fits && <p className="mt-2 text-[11px] font-medium text-destructive" data-testid={`billing-plan-too-small-${p.id}`}>{tooSmall(p, billing.usage)}</p>}
            </button>
          );
        })}
      </div>
    </div>
  );
};
